import './summary-card.scss';

function SummaryCard ({
    loading,
    contentType,
    sentiment,
    onClick
} : {
    loading: boolean,
    contentType: string,
    sentiment: number,
    onClick: () => void
}){
    const getSentimentIcon = (sentiment: number) => {
        return {
            0: 'fa-ban',
            1: 'fa-thumbs-up',
            2: 'fa-thumbs-down',
            3: 'fa-smile-beam',
            4: 'far fa-frown',
            5: 'fa-balance-scale',
            6: 'fa-meh',
            7: 'fa-meh-blank'
        } [sentiment] || '';
    }

    const getSentimentDescription = (sentiment: number) => {
        return {
            0:"None",
            1: "True",
            2: "False",
            3: "Positive",
            4: "Negative",
            5: "Balanced",
            6: "Mixed",
            7: "Neutral"
        } [sentiment] || '';
    }

    return (
        <div className={`summary-card sentiment-${sentiment}`} onClick={onClick}>
            <i className={`fas ${getSentimentIcon(sentiment)} sentiment-icon`}></i>
            <p className="card-heading">{loading ? <i className="fal fa-spinner fa-spin"></i> : `${contentType}`}</p>
            <p className="sentiment-description">{loading ? <i className="fal fa-spinner fa-spin"></i> : `${getSentimentDescription(sentiment)}`}</p>
        </div>
    )
}

export default SummaryCard;